import React from "react";
import AbstractButton from "../components/AbstractButton";
import ForegroundColorSet from "../../utilities/enums/ForegroundColorSet";
import BackgroundColorSet from "../../utilities/enums/BackgroundColorSet";
import { ReactComponent as CancelIcon } from "../../assets/icons/backspace-20-regular.svg?react";
import { ReactComponent as ContinueIcon } from "../../assets/icons/forward-chevrons.svg?react";

const StockLargeWarning = (props: {
  showLargeWarning: boolean;
  onNavigate(): void;
  onCancel(): void;
}) => {
  return (
    <>
      <div
        className={
          "finish-page " +
          (props.showLargeWarning ? "modal-open" : "modal-closed")
        }
      >
        <div
          id="main-menu-modal-mask"
          onClick={props.onCancel}
          className="modal-mask"
        ></div>
        <div id="large-warning-box" className="modal-page finish-page">
          <p id="finish-page-title">Warning: Large Stock Check</p>
          <div className="info-page-section">
           For optimal performance, we recommend limiting stock checks to under 10,000 items. Exceeding this may slow the system and affect other users. Proceed?
          </div>
          <div className="modal-button-span"> 
            <AbstractButton 
                id="stock-warning-cancel-button"
                text="Cancel"
                icon={<CancelIcon width="100%" height="100%"/>}
                disabled={false}
                activeColor={ForegroundColorSet.Red}
                background={BackgroundColorSet.Black1}
                specialClass={null}
                actionCallback={props.onCancel}
            />
             <AbstractButton 
                id="stock-warning-continue-button"
                text="Continue"
                icon={<ContinueIcon width="100%" height="100%"/>}
                disabled={false}
                activeColor={ForegroundColorSet.Blue}
                background={BackgroundColorSet.Black1}
                specialClass={null}
                actionCallback={props.onNavigate}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default StockLargeWarning;
